import React, { useEffect, useState } from "react";

function Navbar({ activePage, onNavigate }) {
    const [time, setTime] = useState("");
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const updateClock = () => {
            const now = new Date();
            setTime(now.toTimeString().slice(0, 8));
        };
        updateClock();
        const interval = setInterval(updateClock, 1000);
        return () => clearInterval(interval);
    }, []);

    const handleNav = (page) => {
        setMenuOpen(false);
        onNavigate(page);
    };

    const pages = [
        { key: "live", label: "Live" },
        { key: "results", label: "Results" },
        { key: "schedule", label: "Schedule" },
        { key: "stats", label: "Stats" },
        { key: "standings", label: "Standings" },
    ];

    return (
        <div className="nav-wrap">
            <nav>
                <div className="logo" onClick={() => handleNav("live")}>
                    {process.env.REACT_APP_RULE === "3" ? (
                        <img src="/logos/parimatch.png" alt="Parimatch" className="logo-img" />
                    ) : process.env.REACT_APP_RULE === "5" ? (
                        <img src="/logos/dimcl.png" alt="DimCL" className="logo-img" />
                    ) : process.env.REACT_APP_RULE === "6" ? (
                        <img src="/logos/1win.png" alt="1win" className="logo-img" />
                    ) : (
                        <img src="/logos/betbazar.png" alt="Betbazar" className="logo-img" />
                    )}
                    <div className="logo-pill">Virtual IPL</div>
                </div>

                <ul className="nav-links">
                    {pages.map(p => (
                        <li key={p.key}>
                            <a className={activePage === p.key ? "active" : ""}
                               onClick={() => handleNav(p.key)}>
                                {p.label}
                            </a>
                        </li>
                    ))}
                </ul>

                <div className="nav-right">
                    <div className="nav-time">{time}</div>
                    <div className="live-ping">
                        <div className="ping-dot"></div>LIVE
                    </div>
                    <button
                        className={`nav-hamburger ${menuOpen ? "open" : ""}`}
                        onClick={() => setMenuOpen(prev => !prev)}
                        aria-label="Toggle menu"
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>
            </nav>

            <div className={`nav-mobile-menu ${menuOpen ? "open" : ""}`}>
                {pages.map(p => (
                    <a key={p.key}
                       className={activePage === p.key ? "active" : ""}
                       onClick={() => handleNav(p.key)}>
                        {p.label}
                    </a>
                ))}
            </div>
        </div>
    );
}

export default Navbar;